import service from "@/utils/requestAdmin";

/**
 * 获取选品库列表以及商品总数
 */
export function getSelectionListApi(params) {
    return service({
        url: '/selection-topic',
        method: 'get',
        params,
    })
}

/**
 * 获取所有选品库
 */
export function getTopicListApi(params) {
    return service({
        url: '/selection-topic/list',
        method: 'get',
        params,
    })
}

/**
 * 修改选品库名字
 * @param data
 * @returns {*}
 */
export function editSaveTopicApi(data) {
    return service({
        url: '/selection-topic',
        method: 'put',
        data,
    })
}

/**
 * 复制新选品库
 * @param data
 * @returns {*}
 */
export function copyTopicApi(data) {
    return service({
        url: '/selection-topic/copyTopic',
        method: 'POST',
        data,
    })
}

/**
 * 删除选品库
 * @param data
 * @returns {*}
 */
export function delTopicApi(params) {
    return service({
        url: '/selection-topic',
        method: 'DELETE',
        params,
    })
}

/**
 * 修改选品库关键词
 */
export function editSaveTopicKeywordApi(data) {
    return service({
        url: '/selection-topic/updateKeywords',
        method: 'put',
        data,
    })
}

/**
 * 获取选品库可选择商品列表
 * @param params
 * @returns {*}
 */
export function getListTopicApi(data) {
    return service({
        url: '/selection-topic-goods-relation',
        method: 'post',
        data,
    })
}

/**
 * 获取选品库可选择商品列表条数
 * @param params
 * @returns {*}
 */
export function getListTopicCountApi(data) {
    return service({
        url: '/selection-topic-goods-relation/count',
        method: 'post',
        data,
    })
}

/**
 * 将商品挑选到选品库中
 */
export function updateGoodsPriceApi(data) {
    return service({
        url: '/selection-topic-goods-relation/addSelection',
        method: 'POST',
        data,
    })
}

/**
 * 一键挑选
 */
export function pushAllSelGoodsApi(data) {
    return service({
        url: '/selection-topic-goods-relation/pushAllSelGoods',
        method: 'POST',
        data
    })
}
/**
 * 创建选品库
 */
export function createTopicApi(data) {
    return service({
        url: '/selection-topic',
        method: 'POST',
        data,
    })
}

/**
 * 获取已选择商品
 */
export function getSelectedPageApi(data) {
    return service({
        url: '/selection-topic-goods-relation/getSelectedPage',
        method: 'post',
        data,
    })
}

export function getSelectedTotalApi(data) {
    return service({
        url: '/selection-topic-goods-relation/getSelectedTotal',
        method: 'post',
        data,
    })
}

/**
 * 修改排序
 */
export function updateSortApi(data) {
    return service({
        url: '/selection-topic-goods-relation/modifySorting',
        method: 'PUT',
        data,
    })
}

/**
 * 修改加价规则
 */
export function updateTopicGoodsDisPriceApi(data) {
    return service({
        url: '/selection-topic-goods-relation/markup',
        method: 'PUT',
        data,
    })
}

/**
 * 删除商品
 */
export function deleteGoodsApi(data) {
    return service({
        url: '/selection-topic-goods-relation/delSelected',
        method: 'DELETE',
        data
    })
}

export function updateMarketPriceApi(data) {
    return service({
        url: '/selection-topic-goods-relation/updateMarketPrice',
        method: 'POST',
        data
    })
}

/**
 * 清空选品库
 */
export function clearTopicApi(params) {
    return service({
        url: '/selection-topic-goods-relation/clear',
        method: 'DELETE',
        params,
    })
}
/**
 * 导出选品库
 */
export function exportTopicApi(params) {
    return service({
        url: '/selection-topic-goods-relation/exportSelectedTopicGoods',
        method: 'get',
        responseType: 'blob',
        params,
    })
}

/**
 * 获取商品变动
 */
export function getGoodsChangePageApi(params) {
    return service({
        url: '/topic-goods-log/page',
        method: 'get',
        params,
    })
}

/**
 * 获取商品价格变动
 */
export function getGoodsPriceTrendApi(params) {
    return service({
        url: '/topic-goods-log/priceTrend',
        method: 'get',
        params,
    })
}

export function getAllGoodsPriceTrendApi(params) {
    return service({
        url: '/topic-goods-log/allPriceTrend',
        method: 'get',
        params,
    })
}

export function getOnlyGoodsPriceTrendApi(params) {
    return service({
        url: '/topic-goods-log/onlyPriceTrend',
        method: 'get',
        params,
    })
}


export function accordingSearchAddSelectionApi(data) {
    return service({
        url: '/download/searchGoodsAddSelection',
        method: 'post',
        data,
    })
}


export function showGoodsInTopicApi(params) {
    return service({
        url: '/selection-topic-goods-relation/getShowGoodsInTopic',
        method: 'get',
        params,
    })
}

export function loadSimilarProductsApi(data) {
    return service({
        url: '/selection-topic-goods-relation/loadSimilarProducts',
        method: 'post',
        data,
    })
}

export function batchSaveProductsApi(data) {
    return service({
        url: '/selection-topic-goods-relation/batchSaveProducts',
        method: 'post',
        data,
    })
}

export function batchEditProductsApi(data) {
    return service({
        url: '/selection-topic-goods-relation/batchEditProducts',
        method: 'post',
        data,
    })
}

export function getTopicTagsListApi(params) {
    return service({
        url: '/selection-topic-search-tags/list',
        method: 'get',
        params,
    })
}

export function saveTopicTagApi(data) {
    return service({
        url: '/selection-topic-search-tags/save',
        method: 'post',
        data,
    })
}



